<template>
  <div>
    <el-button type="primary" style="font-size: 18px" @click="openForm"
    >Записаться на прием
    </el-button
    >
    <el-dialog :visible.sync="open" title="Записаться на прием">
      <div style="font-size: 16px; margin-bottom:15px" v-if="disabledForm">
        <a class="app-link" @click="openLoginForm">Войдите</a> в личный кабинет
        или
        <a class="app-link" href="/account/register/">пройдите регистрацию</a>
      </div>

      <el-form
        :model="appointment"
        :rules="rules"
        ref="appointmentForm"
        :disabled="disabledForm"
      >
        <el-row>
          <el-col>
            <el-form-item
              label="Направление"
              prop="division"
              :error="errors.division"
            >
              <br>
              <v-select label="name" placeholder="Выберите направление" @input="handleChangeDivision"
                        :reduce="divisions => divisions.id"
                        :options="divisions"
                        v-model="appointment.division">
                <!-- eslint-disable-next-line vue/no-unused-vars  -->
                <template #no-options="{ search, searching, loading }">
                  Нет данных
                </template>
              </v-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="Услуга" prop="service" :error="errors.service">
              <br>
              <v-select label="name" placeholder="Выберите услугу" @input="handleChangeService"
                        :reduce="filterService => filterService.id"
                        :options="filterService"
                        v-model="appointment.service">
                <!-- eslint-disable-next-line vue/no-unused-vars  -->
                <template #no-options="{ search, searching, loading }">
                  Нет данных
                </template>
              </v-select>
            </el-form-item
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="Комментарий"
              prop="comment"
              :error="errors.comment"
            >
              <el-input
                v-model="appointment.comment"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="open = false">Отмена</el-button>
        <el-button
          type="primary"
          @click="createAppointment('appointmentForm')"
          :disabled="disabledForm"
          :loading="loading"
        >Записаться</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  props: ["filial", "is_auth", "division_id", "service_id"],
  data() {
    return {
      open: false,
      divisions: [],
      services: [],
      appointment: {
        division: "",
        service: "",
        comment: "",
        filial: ""
      },
      errors: {},
      loading: false,
      rules: {
        division: [
          {
            required: true,
            message: "Обязательное поле",
            trigger: "change"
          }
        ],
        service: [
          {
            required: true,
            message: "Обязательное поле",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    filterService() {
      return this.appointment.division
        ? this.services.filter(
          service => service.division === this.appointment.division
        )
        : this.services;
    },
    disabledForm() {
      return !this.is_auth;
    }
  },
  methods: {
    openLoginForm() {
      this.open = false;
      document.getElementById("sign-in-btn").click();
    },
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },
    openForm() {
      this.loading = false;
      this.open = true;
      this.resetForm("appointmentForm");
    },
    initialData() {
      let params = {filial: this.filial};
      api.get(`/divisions/`, {params}).then(response => {
        this.divisions = response.data;
        if (this.division_id) {
          let division = this.divisions.find(division => division.id === this.division_id);
          if (division){
            this.appointment.division = division.id;
          }
        }
      });
      api.get(`/services/`, {params}).then(response => {
        this.services = response.data;
        if (this.service_id) {
          let service = this.services.find(service => service.id === this.service_id);
          if (service) {
            this.appointment.service = service.id;
            this.handleChangeService(this.service_id);
          }
        }
      });
    },
    handleChangeDivision() {
      this.appointment.service = "";
    },
    handleChangeService(val) {
      if (!this.appointment.division) {
        let service = this.services.find(service => service.id === val);
        if (service) {
          this.appointment.division = service.division;
        }
      }
    },
    createAppointment(formName) {
      this.loading = true;
      this.errors = {};
      this.$refs[formName].validate(valid => {
        if (valid) {
          api
            .post(`/create-appointment/`, this.appointment)
            .then(response => {
              this.$refs[formName].resetFields();
              this.loading = false;
              window.location.href = "/lk/patient/";
            })
            .catch(error => {
              if (error.response.data.error) {
                this.$message.error(error.response.data.error);
              } else {
                for (const [key, value] of Object.entries(error.response.data)) {
                  this.$set(this.errors, key, value.join());
                }
              }
              this.loading = false;
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    }
  },
  created() {
    this.appointment.filial = this.filial;
    this.initialData();
  }
};
</script>

<style scoped lang="scss">
.app-link {
  color: #e67373;
}
</style>
